import { useEffect, useState } from 'react';
import { UtilityService } from '../../../services/UtilityService';

interface Props {
    MediaUrl: string;
    controls: boolean;

}
const Audio = (props: Props) => {
    const [url, setUrl] = useState<string>("")
    useEffect(() => {
        UtilityService.convertUrlToBlob(props.MediaUrl).then(res => {
            setUrl(res)
        });
    }, [])

    return (
        <audio controls={props.controls} src={url} className="display-audio" controlsList="nodownload" />
    )
}
export default Audio